/**
 * Utility functions for handling and converting image paths
 */

/**
 * Converts a DDS path to a WebP image URL
 * @param ddsPath The original DDS path from the item properties
 * @returns The converted WebP URL or null if the input is empty
 */
export const convertDDSToWebp = (ddsPath: string | undefined, game: string): string => {
  if (!ddsPath) return '';

  // Clean the path and ensure proper URL encoding
  const cleanPath = ddsPath.replace('.dds', '.webp');

  if (game === 'PoE2') {
    return `https://cdn.poe2db.tw/image/${cleanPath}`;
  }

  return `https://cdn.poedb.tw/image/${cleanPath}`;
};
